export default __webpack_public_path__ + "static/media/H1015.6.aa46f52b.mp3";